export default __webpack_public_path__ + "static/media/13.6e8d1014.png";